<template>
  <div style="display: inline-block; min-height: 60px" data-testid="quoteProductHeaderGroup">
    <span style="display: block; font-size: 16px; line-height: 18px;" v-if="coverageOption || submissionId" data-testid="coverageAndIdText">
      <span v-if="coverageOption">{{coverageOption}}</span>
      <span v-if="coverageOption && submissionId">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
      <span v-if="submissionId">{{submissionId}}</span>
    </span>

    <span style="display: block; font-size: 12px; line-height: 14px;" v-if="agency" data-testid="agencyText">
      <span v-if="agency">{{agency}}</span>
    </span>

    <span style="display: block; font-size: 12px; line-height: 14px;" v-if="insuredName" data-testid="insuredNameText">
      <span>{{insuredName}}</span>
    </span>

    <span style="display: block; font-size: 12px; line-height: 14px;" v-if="riskAddress" data-testid="riskAddressText">
      <span v-if="riskAddress">{{riskAddress}}</span> <span v-if="riskCounty">({{riskCounty}}&nbsp;County)</span>
    </span>

    <span style="display: block; font-size: 12px; line-height: 14px;" v-if="effectiveDate || expirationDate" data-testid="effectiveDateText">
      <span v-if="effectiveDate">{{effectiveDate}}</span>
      <span v-if="effectiveDate && expirationDate">&nbsp;-&nbsp;</span>
      <span v-if="expirationDate">{{expirationDate}}</span>
    </span>

    <span style="display: block; font-size: 12px; line-height: 14px;" v-if="isSupportOrHigher">
      <router-link :to="submissionMessageTracing" target="_blank">Message Tracing</router-link>
    </span>
  </div>
</template>

<script>
import { formatDateForDisplay } from '@/scripts/helper';

export default {
  name: 'QuoteProductHeader',
  props: {
    submission: Object,
    form: {
      type: String,
      default: null
    }
  },
  methods: {
    agencyDisplay (agency, agent) {
      const agentName = agent?.Name ?? '';
      return agency.OrgName + ' (' + agency.City + ', ' + agency.State + ') - ' + agentName;
    }
  },
  computed: {
    coverageOption () {
      let coverageOption = this.$store.getters.getSubmissionDataValue('CoverageOption');
      if (coverageOption) {
        coverageOption = coverageOption.toUpperCase();
      } else {
        coverageOption = null;
      }
      return coverageOption;
    },
    submissionId () {
      let submissionId = "";
      const quoteForm = this.$store.getters.getForm('quoteForm');
      if (quoteForm && quoteForm.data && quoteForm.ResultId) {
        submissionId = quoteForm.ResultId;
      }
      return submissionId;
    },
    agency () {
      const agent = this.$store.getters.getSubmissionDataValue('Agent');
      let agency = this.$store.getters.getSubmissionDataValue('Agency');
      if (agency) {
        return this.agencyDisplay(agency, agent);
      }
      return '';
    },
    insuredName () {
      const entityName = this.$store.getters.getSubmissionDataValue('EntityName') || null;
      const firstName = this.$store.getters.getSubmissionDataValue('FirstName');
      const lastName = this.$store.getters.getSubmissionDataValue('LastName');
      if (!entityName) {
        if (firstName && !lastName) {
          return `${firstName}`;
        } else if (!firstName && lastName) {
          return `${lastName}`;
        } else if (!firstName && !lastName) {
          return '';
        }
        return `${firstName} ${lastName}`;
      }
      return entityName;
    },
    riskAddress () {
      const risk = this.$store.getters.getSubmissionDataValue('Risk');
      if (risk && risk.Formatted) {
        return risk.Formatted;
      } else {
        return null;
      }
    },
    riskCounty () {
      const risk = this.$store.getters.getSubmissionDataValue('Risk');
      if (risk && risk.Formatted) {
        return risk.County;
      } else {
        return null;
      }
    },
    effectiveDate () {
      return formatDateForDisplay(this.$store.getters.getSubmissionDataValue('EffectiveDate'));
    },
    expirationDate () {
      return formatDateForDisplay(this.$store.getters.getSubmissionDataValue('ExpirationDate'));
    },
    isSupportOrHigher () {
      return this.$store.getters.userHasRole('support') ||
        this.$store.getters.userHasRole('admin');
    },
    submissionMessageTracing () {
      const submission = this.$store.getters['submissionState/getSubmission'];
      return `/support-tools/message-tracing/${submission?.guid || ''}`;
    }
  }
};
</script>
